import {
  ContentSectionHeader,
  Divider,
  Hyperlink,
  InlineAlert,
  NumberedLabelSectionHeader,
} from 'br2s-ui-componentlibrary_r2_02';
import './InstructionDetails.scss';
import { IInstructionListItem } from './interfaces';
import Richtext from '@/components/Richtext/Richtext';
import FileSelector from '@/components/FileSelector/FileSelector';
export interface InstructionDetailsProps {
  contentSectionHeader: string;
  instructionListItems: IInstructionListItem[];
  inlineHeadline?: string;
  inlineAlertText?: string;
  contentSectionHeaderLevel?: 1|2|3;
  contentSectionDescription?: string
}

function InstructionIntroDetail({
  contentSectionHeader,
  contentSectionDescription,
  instructionListItems,
  inlineHeadline,
  inlineAlertText,
  contentSectionHeaderLevel = 3
}: InstructionDetailsProps) {

  return (
    <div
      id="instruction-introduction-container"
      className="instruction-introduction-details-container"
    >
      <div className="introduction-divider">
        <Divider id="information-snippet-divider" />
      </div>
      <div>
        <ContentSectionHeader
          id="headline-content-one"
          headerLabel={contentSectionHeader}
          level={contentSectionHeaderLevel}
        />
        {contentSectionDescription && (
          <div className='headline-content-desc'>
            <Richtext content={contentSectionDescription}/>
          </div>
        )}
        <div className="instruction-item-list">
          {instructionListItems.map((listItem, index) => (
            <div key={listItem.id} id={listItem.id} className="instruction-item">
              {listItem.title && (
                <NumberedLabelSectionHeader
                  id={`instruction-item-header-${index + 1}`}
                  badgeValue={index + 1}
                  headerLabel={listItem.title}
                />
              )}
              {listItem.text && (
                <div className="item-summaries">
                  <Richtext content={listItem.text}/>
                </div>
              )}
              {listItem.links.length > 0 && (
                <div className="item-link" key="listItem">
                  {listItem.links.map((link) => (
                    <div key={link.id} className="intro-links">
                      <Hyperlink
                        fontStyle="base"
                        href={link.redirectUrl}
                        id={link.id}
                        label={link.label}
                        isOpenNewTab={link.isOpenNewTab}
                      />
                    </div>
                  ))}
                </div>
              )}
            {Object.keys(listItem.fileDownload).length ? <FileSelector fileLink={listItem.fileDownload} label=''/> : ''}
            </div>
          ))}
        </div>
        <div className="instruction-note-information">
          {inlineAlertText && inlineHeadline && (
            <InlineAlert
              id="inline-alert-introduction"
              headline={inlineHeadline}
              subHeadline=""
              type="informative"
            >
              <Richtext content={inlineAlertText}/>
            </InlineAlert>
          )}
        </div>
      </div>
    </div>
  );
}

export default InstructionIntroDetail;
